import { render, staticRenderFns } from "./HistorySettingMenu.vue?vue&type=template&id=51dffa87&scoped=true"
import script from "./HistorySettingMenu.vue?vue&type=script&lang=js"
export * from "./HistorySettingMenu.vue?vue&type=script&lang=js"
import style0 from "./HistorySettingMenu.vue?vue&type=style&index=0&id=51dffa87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dffa87",
  null
  
)

export default component.exports